import $ from 'jquery';
import _ from 'lodash';
import Cookies from 'cookies';
import ComponentBasePrototype from 'ComponentBasePrototype';

export default class ContentArticle extends ComponentBasePrototype {
  /**
   * {@inheritdoc}
   */
  build() {
    this.articleId = this.data.articleId;
    this.feedbackContainer = this.node.find('.content-article__feedback-container');
    this.feedbackCommentsTextArea = this.node.find('textarea[name="comments"]');
    this.feedbackCommentsArea = this.node.find('.content-article__feedback-comments');
    this.thumbsContainer = this.node.find('.content-article__thumbs-container');
    this.feedbackTitlePlaceHolder = this.node.find('.content-article__feedback-title');
    this.feedbackTitle = this.node.find('.content-article__feedback-title h3');
    this.consent = this.node.find('.content-article__feedback-consent');
    this.handleFeedbackEvents();

    this.node.find('.content-article__back-link--simple').on('click', (e) => {
      if (document.referrer && window.history.length > 1 && _.startsWith(document.referrer, window.top.location.origin)) {
        e.preventDefault();
        window.history.back();
      }
    });

    this.node.find('.content-article__next-prev-item--left').mouseover(() => {
      this.node.find('.content-article__next-prev-bg--left').addClass('content-article__next-prev-bg--hover');
    });

    this.node.find('.content-article__next-prev-item--left').mouseout(() => {
      this.node.find('.content-article__next-prev-bg--left').removeClass('content-article__next-prev-bg--hover');
    });

    this.node.find('.content-article__next-prev-item--right').mouseover(() => {
      this.node.find('.content-article__next-prev-bg--right').addClass('content-article__next-prev-bg--hover');
    });

    this.node.find('.content-article__next-prev-item--right').mouseout(() => {
      this.node.find('.content-article__next-prev-bg--right').removeClass('content-article__next-prev-bg--hover');
    });

    const youtubeWrappers = this.node.find('.youtube-embed-wrapper');

    youtubeWrappers.each((index, element) => {
      $(element).removeAttr('style');
      $(element).find('iframe').removeAttr('style');
    });

    const iframes = this.node.find('p > iframe');
    const iframesInsideLinks = this.node.find('p > a > iframe');

    // Move all iframes outside of their parent p-tags
    iframes.each((index, element) => {
      const parent = $(element).parent();
      parent.before(element);
      parent.remove();
    });

    // Move all links with iframes outside of their parent p-tags
    iframesInsideLinks.each((index, element) => {
      const parent = $(element).parent().parent();
      const link = $(element).parent();
      parent.before(link);
      parent.remove();
    });

    return true;
  }

  handleFeedbackEvents() {
    const voteCookieValue = this.getVoteCookieValue();
    if (!voteCookieValue) {
      this.feedbackTitlePlaceHolder.css('display', 'inline-block');
      this.thumbsContainer.css('display', 'inline-block');
    }
    this.node.on('click', '.content-article__thumbs-container', (event) => this.vote($(event.currentTarget)));
    this.node.on('click', '.content-article__feedback-comments-submit', (event) => {
      event.preventDefault();
      this.addDownVoteComments(this.feedbackCommentsTextArea.val().trim());
    });
  }

  vote(containerNode) {
    const vote = containerNode.data('vote');
    this.updateVotes(vote);
    this.displayThankyouMessage();
  }

  updateVotes(vote) {
    $.ajax({
      type: 'POST',
      url: '/.rest/voting/addVote',
      contentType: 'application/json',
      async: false,
      data: JSON.stringify({
        jcrId: this.articleId,
        vote,
        url: window.location.pathname,
      }),
      success: () => {
        Cookies.set(this.getCookieName(), vote, { expires: 365 * 24 * 60 * 60 });
      },
    });
  }

  addDownVoteComments(feedbackComments) {
    $.ajax({
      type: 'POST',
      url: '/.rest/voting/downVoteComments',
      contentType: 'application/json',
      async: false,
      data: JSON.stringify({
        jcrId: this.articleId,
        feedbackComments,
      }),
    });

    this.displayThankyouMessage();
  }

  /**
   * Get cookie name
   * @return {string}
   */
  getCookieName() {
    return `thumbs-${this.articleId}`;
  }

  /**
   * Get vote cookie value
   * @return {bool} vote value
   */
  getVoteCookieValue() {
    return Cookies.get(this.getCookieName());
  }

  displayFeedbackArea() {
    this.thumbsContainer.css('display', 'none');
    this.feedbackTitle.text('Harmi, mutta korjataan asia!');
    this.consent.fadeIn(300).css('display', 'block');
    this.feedbackCommentsArea.fadeIn(300).css('display', 'block');
  }

  displayThankyouMessage() {
    this.thumbsContainer.css('display', 'none');
    this.consent.css('display', 'none');
    this.feedbackCommentsArea.css('display', 'none');
    this.feedbackTitle.fadeIn(300).text('KIITOS!');
    this.feedbackTitle.fadeOut(2000);
  }
}
